import { useTranslation } from "react-i18next";
import AppTable, { ColumnConfig } from "../../../../components/AppTable/AppTable";
import TextPill from "../../../../components/TextPill";
import { SectionPermissionTypeEnum } from "../../../../types/SectionPermissionTypesEnum";
import { Pagination } from "../../../../types/Pagination";
import { AlertValuesActions, AlertValuesListFields } from "../types";

interface AlertValuesTableProps {
    alertValuesData: Pagination<AlertValuesListFields>;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    alertValuesActions?: AlertValuesActions;
    onExportCsv?: () => void;
}

export default function AlertValuesTable({
    alertValuesData,
    totalPages,
    currentPage,
    pageSize,
    alertValuesActions,
    onExportCsv
}: AlertValuesTableProps) {
    const { t } = useTranslation(["common", "claim", "genericDic", "alert"]);

    const columns: ColumnConfig<AlertValuesListFields>[] = [
        {
            header: t("alert:alertValue", { defaultValue: "Value" }),
            key: "value",
            render: (item) => <div style={{ textAlign: "center" }}>{item.value}</div>
        },
        {
            header: t("alert:alertType", { defaultValue: "Generate alert" }),
            key: "alertType",
            render: (item) => {
                const isWithAlert = item.alertType === t("claim:withAlert");
                if (!isWithAlert) {
                    return <span>{item.alertType}</span>;
                }

                return (
                    <TextPill
                        label={item.alertType}
                        backgroundColor="#dc3545"
                    />
                );
            }
        },
        {
            header: t("alert:form.criteria", { defaultValue: "Criteria" }),
            key: "criteria"
        },
        //TODO: Descomentar cuando hayan vigencia
        // {
        //     header: t("alert:validityStartDate", { defaultValue: "Validity start date" }),
        //     key: "validStartDate"
        // },
        // {
        //     header: t("alert:validityEndDate", { defaultValue: "Validity end date" }),
        //     key: "validEndDate"
        // }
    ];

    return (
        <AppTable<AlertValuesListFields>
            data={alertValuesData.items || []}
            columns={columns}
            emptyMessage={t("genericDic:nonRegisters")}
            t={t}
            hasActions={true}
            onDelete={alertValuesActions?.onDelete}
            onView={alertValuesActions?.onView}
            hasPagination={true}
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            paginationType="alerts"
            onExportCsv={onExportCsv}
            sectionPermission={SectionPermissionTypeEnum.ALERT_CONFIG}
        />
    );
}
